﻿import * as paths from './paths';
export default class HeatmapConfigurator {
    constructor(configContainer, rootURL, settings, resourcesHandler, additional) {
        this.resourcesHandler = resourcesHandler;
        this.configContainer = configContainer;
        this.rootURL = rootURL;
        this.settings = settings;
        this.radiusId = 'radius-id';
        this.blurId = 'blur-id';
        this.entityId = 'entity-id';
        this.entityFieldId = 'entity-field-id';
        this.colorPickersId = 'color-pickers-id';
        this.additional = additional;
    }

    init() {
        this.configContainer.innerHTML = this._getTemplate();

        $("#" + this.radiusId).kendoNumericTextBox({
            format: "0",
            decimals: 0,
            min: 0,
            appendTo: '#' + this.radiusId
        });

        if (this.settings.Radius != null) {
            $("#" + this.radiusId).data('kendoNumericTextBox').value(this.settings.Radius);
        }

        $("#" + this.blurId).kendoNumericTextBox({
            format: "0",
            decimals: 0,
            min: 0,
            appendTo: '#' + this.blurId
        });

        if (this.settings.Blur != null) {
            $("#" + this.blurId).data('kendoNumericTextBox').value(this.settings.Blur);
        }

        if (this.additional == null || this.additional.idEntity == null) {
            $('#' + this.entityId).kendoComboBox({
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                syncValueAndText: false,
                suggest: true,
                ignoreCase: true,
                appendTo: '#' + this.entityId,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                return this.rootURL + paths.MAP_ENTITY_LAYERS;
                            }
                        }
                    }
                },
                change: (evt) => {
                    $('#' + this.entityFieldId).data("kendoComboBox").value(null);
                    $('#' + this.entityFieldId).data("kendoComboBox").dataSource.read();
                }
            });

            if (this.settings.IdEntity) {
                $('#' + this.entityId).data("kendoComboBox").value(this.settings.IdEntity);
            }
        } else {
            $('#' + this.entityId).kendoComboBox({
                dataTextField: 'Name',
                dataValueField: 'Id',
                filter: 'contains',
                syncValueAndText: false,
                suggest: true,
                ignoreCase: true,
                appendTo: '#' + this.entityId,
                dataSource: []
            });

            $('#' + this.entityId).data("kendoComboBox").value(this.additional.idEntity);
            $('#id-entity-wrapper').hide();
        }

        let isEntity = (this.additional == null || this.additional.Type != 'Geoservice') ? true : false

        if (this.additional == null || this.additional.fields == null) {
            $('#' + this.entityFieldId).kendoComboBox({
                dataTextField: 'FieldName',
                dataValueField: 'FieldName',
                filter: 'contains',
                syncValueAndText: false,
                suggest: true,
                ignoreCase: true,
                appendTo: '#' + this.entityFieldId,
                dataSource: {
                    serverFiltering: false,
                    transport: {
                        read: {
                            dataType: 'json',
                            url: () => {
                                if (isEntity) {
                                    return this.rootURL + paths.MAP_ENTITY_GET_FIELDS + $('#' + this.entityId).data('kendoComboBox').value();
                                } else {
                                    return this.rootURL + paths.MAP_GEOSERVICE_FIELDS + $('#' + this.entityId).data('kendoComboBox').value();
                                }
                            }
                        }
                    }
                }
            });

            if (this.settings.IdEntityField != null) {
                $('#' + this.entityFieldId).data('kendoComboBox').value(this.settings.IdEntityField);
            }
        } else {
            $('#' + this.entityFieldId).kendoComboBox({
                dataTextField: 'FieldName',
                dataValueField: 'FieldName',
                filter: 'contains',
                syncValueAndText: false,
                suggest: true,
                ignoreCase: true,
                appendTo: '#' + this.entityFieldId,
                dataSource: this.additional.fields
            });

            if (this.settings.IdEntityField != null) {
                $('#' + this.entityFieldId).data('kendoComboBox').value(this.settings.IdEntityField);
            }
        }

        if (this.settings.ColorRamp == null || this.settings.ColorRamp.length == 0) {
            this.settings.ColorRamp = ["#FF0000", "#FFFF00", "#00FF00"];
        }

        let template = ``;

        for (let i = 0; i < this.settings.ColorRamp.length; i++) {
            template += `<div class="mb-3 d-flex">
                <input class="ramp-color" type="color" value="` + this.settings.ColorRamp[i] + `">
                <i class="fal fa-times remove-color-id" style="font-weight: bold; cursor: pointer; line-height: 1.7rem; color: red; font-size: 1.1rem; margin-left: 0.5rem; margin-right: 0.75rem;"></i>
            </div>`;
        }

        template += `<i class="fal fa-plus add-color-id" style="font-weight: bold; cursor: pointer; line-height: 1.7rem; color: green; font-size: 1.1rem; margin-left: 0.5rem; margin-right: 0.75rem;"></i>`;

        document.getElementById(this.colorPickersId).innerHTML = template;

        $('#' + this.colorPickersId).on('click', evt => {
            if (evt.target.classList.contains('add-color-id')) {
                let template = `<div class="mb-3 d-flex">
                                    <input class="ramp-color" type="color" value="#ffffff">
                                    <i class="fal fa-times remove-color-id" style="font-weight: bold; cursor: pointer; line-height: 1.7rem; color: red; font-size: 1.1rem; margin-left: 0.5rem; margin-right: 0.75rem;"></i>
                                </div>`;

                $($(evt.target).parent().children()[$(evt.target).parent().children().length - 2]).after(template);
            } else if (evt.target.classList.contains('remove-color-id')) {
                $(evt.target).parent().remove();
            }
        });
    }

    save() {
        let ramps = [];

        let rampInputs = $('.ramp-color');

        for (let i = 0; i < rampInputs.length; i++) {
            ramps.push(rampInputs[i].value);
        }

        return {
            Radius: $("#" + this.radiusId).data('kendoNumericTextBox').value(),
            Blur: $("#" + this.blurId).data('kendoNumericTextBox').value(),
            IdEntity: $('#' + this.entityId).data("kendoComboBox").value(),
            IdEntityField: $('#' + this.entityFieldId).data('kendoComboBox').value(),
            ColorRamp: ramps,
            Type: 'HEATMAP'
        };
    }

    _getTemplate() {
        return `<div class="form-group col-12">
                    <div class="form-row">
                        <div class="col-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.resourcesHandler.get('Radius') + `</label>
                                <input class="form-control" id="` + this.radiusId + `">
                            </div>
                        </div>
                        <div class="col-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.resourcesHandler.get('Blur') + `</label>
                                <input class="form-control" id="` + this.blurId + `">
                            </div>
                        </div>
                    </div>
                    <div class="form-row">
                        <div class="col-6" id="id-entity-wrapper">
                            <div class="form-group">
                                <label class="form-label">` + this.resourcesHandler.get('Entity') + `</label>
                                <div class="form-control" id="` + this.entityId + `"></div>
                            </div>
                        </div>
                        <div class="col-6 mb-3">
                            <div class="form-group">
                                <label class="form-label">` + this.resourcesHandler.get('WeightField') + `</label>
                                <input class="form-control" id="` + this.entityFieldId + `">
                            </div>
                        </div>
                    </div
                    <div class="form-row">
                        <label class="form-label">` + this.resourcesHandler.get('ColorRamp') + `</label>
                        <div class="col-12 mb-3 d-flex p-0" id="` + this.colorPickersId + `">
                            
                        </div>
                    </div>
                </div>`;
    }
}